import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-warning\"><title>资源 115</title><g id=\"icon-warning_图层_2\" data-name=\"图层 2\"><g id=\"icon-warning_图层_1-2\" data-name=\"图层 1\"><path d=\"M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0ZM9.75,5.58a1.25,1.25,0,1,1,2.5,0v6a1.25,1.25,0,0,1-2.5,0ZM11,16.86a1.59,1.59,0,1,1,1.59-1.59A1.59,1.59,0,0,1,11,16.86Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warning.svg
// module id = TcIt
// module chunks = 75